import { PcmpRequestQueueTable } from '../components/PcmpRequests/PcmpRequestQueueTable';

export function PcmpRequestQueuePage() {
  return <PcmpRequestQueueTable />;
}
